import React,{useEffect, useState} from "react";
// import config from "../../../config";
import client from "../../../clients";
import TrainerFilter from "../../../components/search-filter/components/trainer";
import { bulkReassign } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";
import { startLoader, stopLoader } from "../../../lib/utils";

const BulkReassign = (props={
  handleClose:()=>{},
  followups:[],
  followup:null,
  selectedGym:null
}) => {

  const {user,token} = isAuthenticated();
  const [isMemberListOpen, setMemberListOpen] = useState(true);
  const [memberList, setMemberList] = useState([
    // {
    //   name:"Dylan Venderlee Das",
    //   phone: "+91 8383873393"
    // },{
    //   name:"Jonny Walker",
    //   phone: "+91 4583873393"
    // },{
    //   name:"Dylan Venderlee Das",
    //   phone: "+91 8383873393"
    // },{
    //   name:"Jonny Walker",
    //   phone: "+91 4583873393"
    // },{
    //   name:"Dylan Venderlee Das",
    //   phone: "+91 8383873393"
    // },{
    //   name:"Jonny Walker",
    //   phone: "+91 4583873393"
    // }
  ]);

  const [selectedUser,setSelctedUser] = useState('');

  const toggleSelectedUserView = () => {
    setMemberListOpen(!isMemberListOpen)
  }

  const getRecipient = data =>{
    setSelctedUser(data);
  }

  const handleBulkReassign = async event =>{
    try{
      await startLoader()
      const payload = {
        followableIds:memberList.map(data=>data._id),
        userId:selectedUser._id
      }

      const response = await bulkReassign(user._id,token,payload);

      if(response.error){
         new Toast({
          type: "error",
          duration: 3000,
          message: response.error,
        })
      }else{
        props.closeAndReload();
        new Toast({
          type: "success",
          duration: 3000,
          message: "New user assigned sucessfully",
        })
      }
    }catch(error){

    }

    await stopLoader()
  }

  useEffect(()=>{
    //alert(!props.isBulkAction && props.followup);
    //alert(JSON.stringify((!props.isBulkAction && props.followup)?[props.followup]:props.followups))
    setMemberList((!props.isBulkAction && props.followup)?[props.followup]:props.followups)
  },[props]);

  return(
    <div className={`${window.innerWidth > 580 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 580 ? "global-modal-type-2 personal-training-modal flex-item" : "w-full h-full"}`}>
        {/* <div className="global-modal-container d-flex">
          <div className="global-modal-type-2 personal-training-modal flex-item"> */}
        {
          window.innerWidth > 580 && (
            <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.7493 11.0011V6.66775C21.7493 4.11325 21.7493 2.83708 20.9563 2.043C20.1623 1.25 18.8861 1.25 16.3327 1.25H13.0827C10.5293 1.25 9.25202 1.25 8.45902 2.043C7.66602 2.83708 7.66602 4.11325 7.66602 6.66775V15.3344C7.66602 17.8889 7.66602 19.1662 8.45902 19.9603C9.13068 20.6319 10.1501 20.7338 11.9993 20.75M11.9993 5.58333H17.416M11.9993 9.91667H17.416M3.33268 1.25H2.24935C1.96203 1.25 1.68648 1.36414 1.48332 1.5673C1.28015 1.77047 1.16602 2.04602 1.16602 2.33333V17.5L2.79102 20.75L4.41602 17.5V2.33333C4.41602 2.04602 4.30188 1.77047 4.09871 1.5673C3.89555 1.36414 3.62 1.25 3.33268 1.25Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.166 18.584C14.166 18.584 15.791 19.1257 16.8743 20.7506C16.8743 20.7506 18.4993 16.4173 22.8327 14.2507M1.16602 5.58398H4.41602" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white">Bulk Reassign</p>
              </div>
              <div onClick={()=>props.handleClose("")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className='w-full m-t-4' style={{padding:"12px", height: "90%", overflowY:"auto"}}>
          <div className="w-full selected-member-list-container bg-white">
            <div onClick={()=>toggleSelectedUserView()} className="d-flex space-between cursor-pointer" style={{padding: "8px 12px", borderRadius: isMemberListOpen ? "12px 12px 0 0" : "12px",  background: isMemberListOpen ? "#e0e0e0" : "#ffffff"}}>
              <div className="flex-item d-flex">
                <svg className="flex-item m-r-8" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5856 12.3743C12.732 12.3743 14.4719 10.6343 14.4719 8.48793C14.4719 6.34155 12.732 4.60156 10.5856 4.60156C8.4392 4.60156 6.69922 6.34155 6.69922 8.48793C6.69922 10.6343 8.4392 12.3743 10.5856 12.3743Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.75586 22.0908V20.1477C4.75586 19.1169 5.16531 18.1284 5.89415 17.3996C6.62298 16.6708 7.6115 16.2613 8.64222 16.2613H12.5286C13.5593 16.2613 14.5478 16.6708 15.2767 17.3996C16.0055 18.1284 16.415 19.1169 16.415 20.1477V22.0908M17.3865 4.72852C18.2225 4.94256 18.9635 5.42874 19.4926 6.11042C20.0217 6.7921 20.3089 7.63049 20.3089 8.49343C20.3089 9.35637 20.0217 10.1948 19.4926 10.8764C18.9635 11.5581 18.2225 12.0443 17.3865 12.2583M22.2445 22.0908V20.1477C22.2396 19.2899 21.951 18.4579 21.4238 17.7813C20.8965 17.1046 20.1603 16.6215 19.3297 16.407" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item font-weight-700">{memberList.length} Follow Ups Selected</p>
              </div>
              {
                isMemberListOpen ? (
                  <svg className="flex-item" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="29" height="29" rx="14.5" fill="#9C9C9C"/>
                    <path d="M7.65289 6.9745C7.60835 6.92995 7.55546 6.89461 7.49726 6.8705C7.43906 6.84639 7.37668 6.83398 7.31369 6.83398C7.25069 6.83398 7.18831 6.84639 7.13011 6.8705C7.07191 6.89461 7.01903 6.92995 6.97449 6.9745C6.92994 7.01904 6.89461 7.07193 6.8705 7.13013C6.84639 7.18834 6.83398 7.25072 6.83398 7.31372C6.83398 7.37672 6.84639 7.4391 6.8705 7.4973C6.89461 7.55551 6.92994 7.60839 6.97449 7.65294L10.3282 11.0049C8.66743 12.1381 7.51118 13.8716 7.10288 15.8403C7.09005 15.9019 7.08947 15.9654 7.10119 16.0272C7.1129 16.0891 7.13667 16.148 7.17115 16.2006C7.20563 16.2532 7.25014 16.2986 7.30213 16.334C7.35413 16.3694 7.41259 16.3943 7.47419 16.4071C7.53578 16.4199 7.5993 16.4205 7.66112 16.4088C7.72294 16.3971 7.78184 16.3733 7.83447 16.3388C7.8871 16.3044 7.93243 16.2598 7.96786 16.2078C8.00328 16.1558 8.02813 16.0974 8.04096 16.0358C8.22438 15.151 8.58218 14.3116 9.0935 13.5667C9.60482 12.8217 10.2594 12.186 11.019 11.6968L12.5359 13.2128C12.1405 13.4963 11.8116 13.8625 11.572 14.2859C11.3323 14.7093 11.1877 15.1798 11.148 15.6647C11.1084 16.1497 11.1747 16.6374 11.3424 17.0941C11.5101 17.5508 11.7751 17.9656 12.1191 18.3096C12.4631 18.6537 12.8779 18.9187 13.3346 19.0864C13.7913 19.2541 14.279 19.3205 14.7639 19.2808C15.2487 19.2412 15.7192 19.0965 16.1426 18.8568C16.566 18.6172 16.9321 18.2882 17.2157 17.8929L21.3484 22.0268C21.4384 22.1168 21.5604 22.1673 21.6876 22.1673C21.8148 22.1673 21.9369 22.1168 22.0268 22.0268C22.1168 21.9368 22.1673 21.8148 22.1673 21.6876C22.1673 21.5603 22.1168 21.4383 22.0268 21.3484L7.65289 6.9745ZM14.619 12.587L17.8414 15.8096C17.809 14.9653 17.459 14.1643 16.8616 13.5669C16.2642 12.9694 15.4633 12.6195 14.619 12.587ZM12.1334 10.1022L12.9029 10.8717C13.4244 10.7359 13.9612 10.6673 14.5002 10.6676C17.5722 10.6676 20.304 12.8975 20.9584 16.0358C20.9843 16.1603 21.0587 16.2694 21.1651 16.3392C21.2714 16.4089 21.4012 16.4335 21.5257 16.4076C21.6502 16.3817 21.7593 16.3073 21.8291 16.2009C21.8988 16.0946 21.9234 15.9648 21.8975 15.8403C21.1529 12.2708 18.0388 9.70936 14.5002 9.70936C13.6809 9.70936 12.8827 9.84639 12.1334 10.1022Z" fill="white"/>
                  </svg>
                ) : (
                  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="29" height="29" rx="14.5" fill="var(--darkBlue)"/>
                    <path d="M7.81631 16.0359C8.49268 12.8974 11.3201 10.6673 14.5007 10.6673C17.6812 10.6673 20.5076 12.8974 21.185 16.0359C21.2118 16.1604 21.2887 16.2696 21.3989 16.3393C21.509 16.409 21.6432 16.4337 21.7721 16.4077C21.901 16.3818 22.0139 16.3075 22.0861 16.2011C22.1583 16.0947 22.1837 15.9649 22.1569 15.8404C21.3863 12.2706 18.1632 9.70898 14.5007 9.70898C10.8381 9.70898 7.61499 12.2706 6.8444 15.8404C6.81757 15.9649 6.84304 16.0947 6.91521 16.2011C6.98737 16.3075 7.10032 16.3818 7.2292 16.4077C7.35808 16.4337 7.49234 16.409 7.60245 16.3393C7.71255 16.2696 7.78948 16.1604 7.81631 16.0359ZM14.4907 12.584C15.4113 12.584 16.2942 12.9374 16.9452 13.5664C17.5961 14.1954 17.9618 15.0486 17.9618 15.9382C17.9618 16.8277 17.5961 17.6809 16.9452 18.3099C16.2942 18.9389 15.4113 19.2923 14.4907 19.2923C13.5701 19.2923 12.6873 18.9389 12.0363 18.3099C11.3853 17.6809 11.0196 16.8277 11.0196 15.9382C11.0196 15.0486 11.3853 14.1954 12.0363 13.5664C12.6873 12.9374 13.5701 12.584 14.4907 12.584Z" fill="white"/>
                  </svg>
                )
              }
            </div>

            <div className="selected-member-list-scroll-container">
              {
                isMemberListOpen && (
                  memberList.map((data, index) => {
                    return(
                      <div className="d-flex space-between" style={{padding:"12px 12px 12px 12px", borderBottom: memberList.length != index + 1 && "1px solid #E7E7E7"}}>
                        <div className='d-flex flex-item'>
                          {
                            data.logoFileID ?
                              <div className='tr-profile-image d-flex flex-item m-r-8'>
                                <img src={`${client.config.API_URL}/image/file/${data.logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                              </div>
                              : <div className="tr-profile-image d-flex flex-item m-r-8">
                                <p className='flex-item margin-auto'>{`${data.userInfo.full_name}`.trim()[0]}</p>
                              </div>
                          }
                          <div className="flex-item d-flex space-between" style={{width:"80%"}}>
                            <div className="flex-item w-full">
                              <p style={{lineHeight:"14px"}}>{data.userInfo.full_name}</p>
                              <p className='fs-10 color-grey-02 m-t-4' style={{lineHeight:"10px"}}>{data.userInfo.phone}</p>
                            </div>
                          </div>
                        </div>

                        <div className="table-action-button d-flex" style={{backgroundColor: "#FFE4E4", boxShadow:"none"}}>
                          <svg className="flex-item margin-auto" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.616 16.0005C2.168 16.0005 1.78667 15.8431 1.472 15.5285C1.15733 15.2138 1 14.8328 1 14.3855V2.00047H0V1.00047H4V0.230469H10V1.00047H14V2.00047H13V14.3855C13 14.8455 12.846 15.2298 12.538 15.5385C12.23 15.8471 11.8453 16.0011 11.384 16.0005H2.616ZM12 2.00047H2V14.3855C2 14.5648 2.05767 14.7121 2.173 14.8275C2.28833 14.9428 2.436 15.0005 2.616 15.0005H11.385C11.5383 15.0005 11.6793 14.9365 11.808 14.8085C11.9367 14.6805 12.0007 14.5391 12 14.3845V2.00047ZM4.808 13.0005H5.808V4.00047H4.808V13.0005ZM8.192 13.0005H9.192V4.00047H8.192V13.0005Z" fill="#E33A34"/>
                          </svg>
                        </div>
                      </div>
                    )
                  })
                )
              }
            </div>
          </div>
          <p className="fs-14 font-weight-700 color-dark-blue flex-item m-b-12 m-t-12">Assign To</p>
          <TrainerFilter headerView={false} getRecipient={getRecipient} selectedGym={props.selectedGym} />
        </div>
        <div className="w-full" style={{position:"absolute", bottom:0, padding:"12px"}}>
          <div onClick={handleBulkReassign} className="global-button-container global-button-container-active d-flex flex-item" style={{borderRadius:"20px"}}>
            <p className="flex-item">Confirm</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulkReassign;